import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const Deposit: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M9.9997 14.6211L10.9857 18.6151L14.9707 17.6541"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 19.5C21.6381 19.5 21.75 19.6119 21.75 19.75C21.75 19.8881 21.6381 20 21.5 20C21.3619 20 21.25 19.8881 21.25 19.75C21.25 19.6119 21.3619 19.5 21.5 19.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 15.5C21.6381 15.5 21.75 15.6119 21.75 15.75C21.75 15.8881 21.6381 16 21.5 16C21.3619 16 21.25 15.8881 21.25 15.75C21.25 15.6119 21.3619 15.5 21.5 15.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 19.5C1.63807 19.5 1.75 19.6119 1.75 19.75C1.75 19.8881 1.63807 20 1.5 20C1.36193 20 1.25 19.8881 1.25 19.75C1.25 19.6119 1.36193 19.5 1.5 19.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 15.5C1.63807 15.5 1.75 15.6119 1.75 15.75C1.75 15.8881 1.63807 16 1.5 16C1.36193 16 1.25 15.8881 1.25 15.75C1.25 15.6119 1.36193 15.5 1.5 15.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 23.5C21.6381 23.5 21.75 23.6119 21.75 23.75C21.75 23.8881 21.6381 24 21.5 24C21.3619 24 21.25 23.8881 21.25 23.75C21.25 23.6119 21.3619 23.5 21.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 23.5C17.6381 23.5 17.75 23.6119 17.75 23.75C17.75 23.8881 17.6381 24 17.5 24C17.3619 24 17.25 23.8881 17.25 23.75C17.25 23.6119 17.3619 23.5 17.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 23.5C13.6381 23.5 13.75 23.6119 13.75 23.75C13.75 23.8881 13.6381 24 13.5 24C13.3619 24 13.25 23.8881 13.25 23.75C13.25 23.6119 13.3619 23.5 13.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 23.5C9.63807 23.5 9.75 23.6119 9.75 23.75C9.75 23.8881 9.63807 24 9.5 24C9.36193 24 9.25 23.8881 9.25 23.75C9.25 23.6119 9.36193 23.5 9.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 23.5C5.63807 23.5 5.75 23.6119 5.75 23.75C5.75 23.8881 5.63807 24 5.5 24C5.36193 24 5.25 23.8881 5.25 23.75C5.25 23.6119 5.36193 23.5 5.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 23.5C1.63807 23.5 1.75 23.6119 1.75 23.75C1.75 23.8881 1.63807 24 1.5 24C1.36193 24 1.25 23.8881 1.25 23.75C1.25 23.6119 1.36193 23.5 1.5 23.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 10V2C1.5 1.44772 1.94772 1 2.5 1H20.5C21.0523 1 21.5 1.44772 21.5 2V10"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.998H0.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 11.998H16.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0001 18.6166C14.3204 14.855 14.3392 9.21533 11.0441 5.43164"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Deposit;
